export default "__VITE_ASSET__tfD0Kqy$__"